module.exports = __webpack_public_path__ + "img/img-sexybaccarat-d.a5792baa.png";